// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__1xhit","selected":"Chip_selected__NUVDA"};